import { MapDataTypes } from 'types/map'
import { BriefWalletProductType } from 'types/products'

export type CoverageWalletProductsById = Record<string, BriefWalletProductType>

/**
 * check_coverage returns wallet product blobs once in wallet_products and only
 * require_wallet_product_id on each variation_data. Expand back to require_wallet_product
 * for existing Studio/SPA code paths.
 */
export function attachCoverageWalletProductsToMapTypes(
  availableMapTypes: MapDataTypes[],
  walletProducts: CoverageWalletProductsById | undefined
): void {
  if (!walletProducts || !availableMapTypes?.length) {
    return
  }

  for (const mapType of availableMapTypes) {
    const variationData = mapType.variation_data
    if (!variationData || variationData.require_wallet_product) {
      continue
    }
    const productId = variationData.require_wallet_product_id
    if (productId == null) {
      continue
    }
    const walletProduct =
      walletProducts[String(productId)] ?? walletProducts[productId as unknown as string]
    if (walletProduct) {
      variationData.require_wallet_product = walletProduct
    }
  }
}
